import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';
import {
  IAlphaCardOptionDto,
  IAlphaPendingConfirmationDto,
  IAlphaPodContext,
  IAlphaSessionSummary,
  IAlphaStoredMessage,
  ICreateAlphaSessionRequest,
  ICreateAlphaSessionResult,
} from 'services/alpha/types';

export const createAlphaSession = (
  podContext: IAlphaPodContext,
): IResponse<ICreateAlphaSessionResult> =>
  axiosInstance.request({
    method: 'POST',
    url: 'Alpha/chat/sessions',
    data: { podContext } as ICreateAlphaSessionRequest,
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    rejectWithResponse: true,
  });

export const getAlphaMessages = (sessionId: number): IResponse<IAlphaStoredMessage[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `Alpha/chat/sessions/${sessionId}/messages`,
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    rejectWithResponse: true,
  });

export const getAlphaPendingConfirmations = (
  sessionId: number,
): IResponse<IAlphaPendingConfirmationDto[]> =>
  axiosInstance.request({
    method: 'GET',
    url: `Alpha/chat/sessions/${sessionId}/pending-confirmations`,
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    rejectWithResponse: true,
  });

export const cancelAlphaConfirmation = (sessionId: number, token: string): IResponse<void> =>
  axiosInstance.request({
    method: 'POST',
    url: `Alpha/chat/sessions/${sessionId}/cancel`,
    data: { token },
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    rejectWithResponse: true,
  });

export const getAlphaCardOptions = (
  sessionId: number,
  token: string,
  source: string,
  q: string,
): IResponse<IAlphaCardOptionDto[]> =>
  axiosInstance.request({
    method: 'POST',
    url: `Alpha/chat/sessions/${sessionId}/cards/options`,
    data: { token, source, q },
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    rejectWithResponse: true,
  });

export const getAlphaSessionsForContext = (
  crmSourceId: number,
  externalId: string,
): IResponse<IAlphaSessionSummary[]> =>
  axiosInstance.request({
    method: 'GET',
    url: 'Alpha/chat/sessions',
    params: { crmSourceId, externalId },
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    rejectWithResponse: true,
  });
